import React from 'react'
import { withCookies } from 'react-cookie'
import moment from 'moment'
import { Table } from 'antd'
import { Toast, Modal } from 'antd-mobile'
import { HotTable } from '@handsontable/react'
import $ from 'jquery'

import { CopyToClipboard } from 'react-copy-to-clipboard'

import styles from './form.module.css'
import { _printDataForm } from '../../server'
import {
  isQiyeweixinApp,
  genId,
  getWxSignature,
  convertCurrency,
  isWindows,
  getFirstWord,
} from '../ShareUtils'

const ALI_OSS_DOWNLOAD = process.env.ALI_OSS_DOWNLOAD

const FORM_TABLE_COLUMNS = [
  { title: '', dataIndex: 'col_1', key: 'col_1', width: 169, align: 'center' },
  {
    title: '',
    dataIndex: 'col_2',
    key: 'col_2',
    width: 229,
    align: 'left',
    render: (text, row, index) => {
      if (row.col_3) {
        return (
          <div
            contentEditable={false}
            dangerouslySetInnerHTML={{ __html: text }}
          ></div>
        )
      }
      return {
        children: (
          <div
            contentEditable={false}
            dangerouslySetInnerHTML={{ __html: text }}
          ></div>
        ),
        props: {
          colSpan: 3,
        },
      }
    },
  },
  {
    title: '',
    dataIndex: 'col_3',
    key: 'col_3',
    width: 169,
    align: 'center',
    render: (text, row, index) => {
      if (row.col_3) {
        return (
          <div
            contentEditable={false}
            dangerouslySetInnerHTML={{ __html: text }}
          ></div>
        )
      }
      return {
        children: (
          <div
            contentEditable={false}
            dangerouslySetInnerHTML={{ __html: text }}
          ></div>
        ),
        props: {
          colSpan: 0,
        },
      }
    },
  },
  {
    title: '',
    dataIndex: 'col_4',
    key: 'col_4',
    width: 229,
    align: 'left',
    render: (text, row, index) => {
      if (row.col_3) {
        return (
          <div
            contentEditable={false}
            dangerouslySetInnerHTML={{ __html: text }}
          ></div>
        )
      }
      return {
        children: (
          <div
            contentEditable={false}
            dangerouslySetInnerHTML={{ __html: text }}
          ></div>
        ),
        props: {
          colSpan: 0,
        },
      }
    },
  },
]

class FormPrintPage extends React.Component {
  printCanvas_width = 722
  formFieldVisible = {}
  mergeCellIntance
  dataset = [[]]
  hotSettings = {
    mergeCells: true,
    colWidths: 100,
    rowHeights: 30,
    data: this.dataset,
    renderer: function (instance, td, row, col, prop, value, cellProperties) {
      td.innerHTML = value

      if (cellProperties.className) {
        if (cellProperties.className.indexOf('htMiddle') >= 0) {
          td.style.verticalAlign = 'middle'
        } else if (cellProperties.className.indexOf('htTop') >= 0) {
          td.style.verticalAlign = 'top'
        } else if (cellProperties.className.indexOf('htBottom') >= 0) {
          td.style.verticalAlign = 'bottom'
        }

        if (cellProperties.className.indexOf('htLeft') >= 0) {
          td.style.textAlign = 'left'
        } else if (cellProperties.className.indexOf('htCenter') >= 0) {
          td.style.textAlign = 'center'
        } else if (cellProperties.className.indexOf('htRight') >= 0) {
          td.style.textAlign = 'right'
        } else if (cellProperties.className.indexOf('htJustify') >= 0) {
          td.style.textAlign = 'justify'
        }
        if (cellProperties.className.indexOf('htBold') >= 0) {
          td.style.fontWeight = 'bolder'
        }
        if (cellProperties.className.indexOf('htItalic') >= 0) {
          td.style.fontStyle = 'italic'
        }
        if (cellProperties.className.indexOf('htUnderline') >= 0) {
          td.style.textDecoration = 'underline'
        }
      } else {
        td.style.textAlign = 'left'
        td.style.verticalAlign = 'middle'
      }
      td.style.fontSize = cellProperties.ftSize + 'px'
      td.style.color = cellProperties.ftColor
      td.style.background = cellProperties.bgColor
      td.style.border = 'none'

      $(td).removeClass('border-width-1')
      $(td).removeClass('border-width-2')
      $(td).removeClass('border-width-3')
      $(td).removeClass('border-width-4')
      $(td).removeClass('border-width-first-1')
      $(td).removeClass('border-width-first-2')
      $(td).removeClass('border-width-first-3')
      $(td).removeClass('border-width-first-4')
      $(td).removeClass('border-top')
      $(td).removeClass('border-right')
      $(td).removeClass('border-bottom')
      $(td).removeClass('border-left')
      switch (cellProperties.borderType) {
        case 0:
          break
        case 1:
          $(td).addClass('border-bottom')
          break
        case 2:
          $(td).addClass('border-top')
          break
        case 3:
          $(td).addClass('border-left')
          break
        case 4:
          $(td).addClass('border-right')
          break
        case 5:
          $(td).addClass('border-top')
          $(td).addClass('border-right')
          $(td).addClass('border-bottom')
          $(td).addClass('border-left')
          break
        case 6:
          $(td).addClass('border-top')
          $(td).addClass('border-right')
          $(td).addClass('border-bottom')
          $(td).addClass('border-left')
          break
        default:
          // code...
          break
      }
      if (cellProperties.borderWidth > 0) {
        if (col === 0) {
          $(td).css('padding-left', cellProperties.borderWidth + 2 + 'px')
          $(td).addClass('border-width-first-' + cellProperties.borderWidth)
        } else {
          $(td).addClass('border-width-' + cellProperties.borderWidth)
        }
      } else {
        $(td).removeClass('border-top')
        $(td).removeClass('border-right')
        $(td).removeClass('border-bottom')
        $(td).removeClass('border-left')
      }

      return td
    },
    colHeaders: false,
    rowHeaders: false,
    readOnly: true,
  }

  constructor(props) {
    super(props)

    this.hotTableComponent = React.createRef()

    this.state = {
      tipModal: false,
      formDataId: '',
      toaDataForm: {},
      departName: '',
      formFields: [],
      formFieldValues: [],
      Fcolumns: [],
      Frows: [],
      Pcolumns: [],
      Prows: [],
      Ncolumns: [],
      Nrows: [],
      processList: [],
      hasError: false,
      nodeExFieldList: [],
      topWarnShow: true,
      isPrintBtnShow: false,
      jsapiticket: '',
      timestamp: moment().format('X'),
      appId: '',
      nonceStr: genId(),
      childFieldPrintType: 0, //子表单打印方式，0=合并打印，1=分开打印
      formPrintCfg: '',
    }

    if (!this.props.location.query) {
      if (window.location.search) {
        let strSearch = window.location.search
        let params = strSearch.substring(1, strSearch.length).split('&')
        if (params) {
          var isPrint
          params.map((item, i) =>
            item.split('=')[0] === 'formDataId'
              ? (this.state.formDataId = item.split('=')[1])
              : ''
          )
          params.map((item, i) =>
            item.split('=')[0] === 'isPrint'
              ? (isPrint = item.split('=')[1])
              : ''
          )
          if (isPrint && isPrint == 1) {
            this.state.topWarnShow = false
          }
        }
      }
    } else {
      this.state.formDataId = this.props.location.query.formDataId
    }
    if (!this.state.formDataId) {
      this.props.history.push('/')
    } else {
      this.getPrintDataForm()
    }

    this.state.isPrintBtnShow = !isQiyeweixinApp()
  }

  componentDidMount() {
    // 监听浏览器点击返回
    if (window.history && window.history.pushState) {
      window.history.pushState(null, null, document.URL)
      window.addEventListener('popstate', this.handleBack, false)
    }
  }

  componentWillUnmount() {
    window.removeEventListener('popstate', this.handleBack, false)
  }

  handleBack = () => {
    window.sessionStorage.setItem('formDataId', this.state.formDataId)
    this.props.history.goBack()
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true })
  }

  settingWx() {
    // 检查是否在微信/企业微信环境中
    const ua = navigator.userAgent.toLowerCase()
    const isWxWork = ua.includes('wxwork')
    const isWeChat = ua.includes('micromessenger')
    if (!isWxWork && !isWeChat) {
      return
    }
    var formDataId = this.state.formDataId
    var instanceTitle = this.state.toaDataForm.instanceTitle
    var appId = this.state.appId
    var timestamp = this.state.timestamp
    var nonceStr = this.state.nonceStr

    var signature = getWxSignature(
      this.state.jsapiticket,
      nonceStr,
      timestamp,
      process.env.MAIN_HOST + 'formprint?formDataId=' + formDataId
    )

    if (window.wx) {
      window.wx.config({
        beta: true,
        debug: false,
        appId: appId,
        timestamp: timestamp,
        nonceStr: nonceStr,
        signature: signature,
        jsApiList: ['onMenuShareAppMessage'],
      })
      window.wx.ready(function () {
        window.wx.onMenuShareAppMessage({
          title: instanceTitle,
          desc: '我分享了一个表单打印预览',
          link: process.env.MAIN_HOST + 'formprint?formDataId=' + formDataId,
          imgUrl: '',
          success: function () {},
          cancel: function () {},
        })
      })
    }
  }

  formatValue(data, value) {
    if (!value || value.length == 0) {
      return ''
    }
    var fieldType = data.fieldType
    if (fieldType === 'DateField') {
      value = moment(value[0]).format('YYYY-MM-DD')
    } else if (fieldType === 'TimeField') {
      value = moment(value[0]).format('HH:mm')
    } else if (fieldType === 'DateTimeField') {
      value = moment(value[0]).format('YYYY-MM-DD HH:mm')
    } else if (
      fieldType === 'NumberField' ||
      fieldType === 'EquationField' ||
      fieldType === 'StatisticsField'
    ) {
      var tmpValue = value[0]
      if (
        data.moreSetting &&
        undefined != data.moreSetting.decimalPoint &&
        data.moreSetting.decimalPoint != -1
      ) {
        tmpValue = parseFloat(tmpValue + '').toFixed(
          data.moreSetting.decimalPoint
        )
      }
      if (data.isCapital == 'true') {
        tmpValue =
          '¥' +
          tmpValue +
          '<br>大写金额（人民币）：' +
          convertCurrency(value[0])
      }
      value = tmpValue
    } else if (
      fieldType === 'TextField' ||
      fieldType === 'TextArea' ||
      fieldType === 'RadioButton'
    ) {
      value = value[0]
    } else if (fieldType === 'CheckBox' || fieldType === 'BusinessField') {
      var tmp = ''
      for (var j = 0; j < value.length; j++) {
        tmp += value[j]
        if (j < value.length - 1) {
          tmp += ', '
        }
      }
      value = tmp
    } else if (fieldType === 'StaffField' || fieldType === 'AccessoryField') {
      var valueTmp = ''
      for (var k = 0; k < value.length; k++) {
        valueTmp += value[k].name
        if (k < value.length - 1) {
          valueTmp += ', '
        }
      }
      value = valueTmp
    } else if (
      value &&
      (fieldType === 'CascadeDropDown' || fieldType === 'CUSTOMIZE_RadioButton')
    ) {
      if (value.length > 1) {
        var valueTmp = ''
        for (var i = 0; i < value.length; i++) {
          valueTmp += value[i]
          if (i < value.length - 1) {
            valueTmp += '/'
          }
        }
        value = valueTmp
      }
    } else if (value && fieldType === 'ImageField') {
      return ''
    } else if (value && fieldType === 'OcrInvoice') {
      // 返回发票识别的 header 文字内容
      if (Array.isArray(value) && value.length > 0) {
        const headers = value.map((item) => {
          const info = item.invoiceInfo || {}
          const type = getFirstWord(info, 'result_type', '') || info.result_type

          // 检查是否无法识别
          const InvoiceNum = getFirstWord(info, 'InvoiceNum', '-')
          const SerialNumber = getFirstWord(info, 'serial_number', '-')
          const InvoiceNumber = getFirstWord(info, 'invoice_number', '-')
          const invoice_num = getFirstWord(info, 'invoice_num', '-')
          const FapiaoHaoma = getFirstWord(info, 'fapiao-haoma', '-')
          if (
            InvoiceNum === '-' &&
            SerialNumber === '-' &&
            InvoiceNumber === '-' &&
            invoice_num === '-' &&
            FapiaoHaoma === '-'
          ) {
            return '无法识别'
          }

          // 根据发票类型返回对应的 header 文字
          switch (type) {
            case 'vat_invoice':
              return (
                getFirstWord(info, 'InvoiceTypeOrg', '—') +
                '【' +
                getFirstWord(info, 'SellerName', '—') +
                '(' +
                getFirstWord(info, 'AmountInFiguers', '—') +
                ')】'
              )
            case 'air_ticket':
              return (
                '飞机行程单【' +
                getFirstWord(info, 'name', '—') +
                '(' +
                getFirstWord(info, 'ticket_rates', '—') +
                ')】'
              )
            case 'taxi_receipt':
              return '出租车票'
            case 'train_ticket':
              return (
                '火车票【' +
                getFirstWord(info, 'name', '—') +
                '(' +
                getFirstWord(info, 'ticket_rates', '—') +
                ')】'
              )
            case 'quota_invoice':
              return '定额发票'
            case 'roll_normal_invoice':
              return '卷票'
            case 'printed_invoice':
              return '机打发票'
            case 'bus_ticket':
              return '汽车票'
            case 'toll_invoice':
              return '过路过桥费'
            case 'ferry_ticket':
              return '船票'
            case 'motor_vehicle_sale_invoice':
              return '机动车销售发票'
            case 'used_vehicle_invoice':
              return '二手车销售发票'
            default:
              return '发票'
          }
        })
        return headers.join('; ')
      }
      return ''
    }

    return value
  }

  getFieldValue(parentId, fieldId, dataList) {
    for (var i = 0; i < dataList.length; i++) {
      if (dataList[i].formFieldId) {
        if (
          (parentId && dataList[i].formFieldId === parentId) ||
          dataList[i].formFieldId === fieldId
        ) {
          if (dataList[i].fieldValue.length > 0) {
            var field = this.getField(fieldId, this.state.formFields)
            if (parentId && dataList[i].formFieldId === parentId) {
              var resultValue = ''
              for (
                let index = 0;
                index < dataList[i].fieldValue.length;
                index++
              ) {
                const element = dataList[i].fieldValue[index]
                if (element.fieldList && element.fieldList[fieldId]) {
                  resultValue += this.formatValue(
                    field,
                    element.fieldList[fieldId]
                  )
                  if (index < dataList[i].fieldValue.length - 1) {
                    resultValue += ', '
                  }
                }
              }
              return resultValue
            } else {
              return this.formatValue(field, dataList[i].fieldValue)
            }
          }
        }
      }
    }
    return ''
  }

  getField(fieldId, dataList) {
    for (var i = 0; i < dataList.length; i++) {
      if (dataList[i].fieldId === fieldId) {
        return dataList[i]
      } else if (
        dataList[i].fieldType === 'ChildField' ||
        dataList[i].fieldType === 'FORMREFCustomerField'
      ) {
        var field = this.getField(fieldId, dataList[i].childFormFields)
        if (field) {
          return field
        }
      }
    }

    return ''
  }

  renderChildForm_(data) {
    var myDataSource = []
    if (data.inputValue.length === 0) {
      data.inputValue = [{ id: 1, key: 1, example: true }]
    } else {
      data.inputValue.map((item, index) => (item.id = index + 1))
    }

    myDataSource = data.inputValue
    for (var i = 0; i < myDataSource.length; i++) {
      for (var val in myDataSource[i]) {
        if (
          myDataSource[i][val] instanceof Array &&
          myDataSource[i][val].length > 0
        ) {
          for (var j = 0; j < myDataSource[i][val].length; j++) {
            if (
              !(myDataSource[i][val][j] instanceof String) &&
              myDataSource[i][val][j].name
            ) {
              myDataSource[i][val][j] = myDataSource[i][val][j].name + ', '
            }
          }
        }
      }
    }

    let columns = [
      {
        title: '序号',
        width: 60,
        dataIndex: 'id',
        key: 'id',
        fixed: 'left',
        align: 'center',
        id: 1,
      },
    ]

    data.childFormFields.map((item) => {
      if (item.moreSetting && item.moreSetting.notPrint == true) {
      } else {
        let column = {
          title: item.fieldTitle,
          dataIndex: item.fieldId,
          key: item.fieldId,
          render: (text, record, index) => {
            if (text && item.fieldType === 'TextArea') {
              var inputValue = record[item.fieldId]
              if (inputValue.length > 1) {
                text = inputValue[0]
              }
            } else if (
              text &&
              (item.fieldType === 'EquationField' ||
                item.fieldType === 'StatisticsField' ||
                item.fieldType === 'NumberField')
            ) {
              if (
                item.moreSetting &&
                undefined != item.moreSetting.decimalPoint &&
                item.moreSetting.decimalPoint != -1
              ) {
                text = parseFloat(text + '').toFixed(
                  item.moreSetting.decimalPoint
                )
              }
              if (item.isCapital && item.isCapital === 'true') {
                text =
                  '¥' +
                  text +
                  '<br>大写金额（人民币）：' +
                  convertCurrency(text)
              }
            } else if (
              text &&
              (item.fieldType === 'CascadeDropDown' ||
                item.fieldType === 'CUSTOMIZE_RadioButton')
            ) {
              if (text.length > 1) {
                var textTmp = ''
                for (var i = 0; i < text.length; i++) {
                  textTmp += text[i]
                  if (i < text.length - 1) {
                    textTmp += '/'
                  }
                }
                text = textTmp
              }
            }
            return (
              <div
                style={{ overflowX: 'auto' }}
                contentEditable={false}
                dangerouslySetInnerHTML={{ __html: text }}
              ></div>
            )
          },
        }
        columns.splice(columns.length, 0, column)
      }
    })

    return (
      <span>
        <div
          className={styles.sgridRowItem}
          style={{
            width: 740,
            fontWeight: 'bold',
            justifyContent: 'center',
            border: 'none',
            top: 70,
            overflow: 'hidden',
          }}
        >
          <span>{data.fieldTitle}</span>
        </div>
        <div
          className={styles.sgridRowItem}
          style={{
            width: 740,
            fontWeight: 'bold',
            justifyContent: 'center',
            border: 'none',
            top: 70,
            overflow: 'hidden',
          }}
        >
          <Table
            className={styles.childFormTable}
            size={'small'}
            bordered={true}
            pagination={false}
            style={{ border: 'none', fontSize: 12 }}
            columns={columns}
            dataSource={myDataSource}
          />
        </div>
      </span>
    )
  }

  renderChildForm(fieldId, fieldTitle, formFields) {
    let resultView = ''
    let dataList = this.state.formFieldValues
    for (var i = 0; i < dataList.length; i++) {
      if (dataList[i].formFieldId === fieldId) {
        resultView = (
          <span>
            {dataList[i].fieldValue.map((item) => {
              return this.renderChildFormTable(
                fieldTitle,
                this.setFormFieldVisibleStatus(formFields),
                item
              )
            })}
          </span>
        )
      }
    }

    return <span>{resultView}</span>
  }

  renderChildFormTable(fieldTitle, formFields, data) {
    let newColumns = []
    let newRows = []
    if (formFields) {
      if (formFields.length <= 8) {
        newColumns = [
          {
            title: '',
            dataIndex: 'col_1',
            key: 'col_1',
            width: 199,
            align: 'center',
          },
          {
            title: '',
            dataIndex: 'col_2',
            key: 'col_2',
            width: 597,
            align: 'left',
            render: (text, record, index) => {
              var item = formFields[index]
              if (item) {
                if (text && item.fieldType === 'TextArea') {
                  var inputValue = record[item.fieldId]
                  if (inputValue.length > 1) {
                    text = inputValue[0]
                  }
                } else if (
                  text &&
                  (item.fieldType === 'EquationField' ||
                    item.fieldType === 'StatisticsField' ||
                    item.fieldType === 'NumberField')
                ) {
                  if (
                    item.moreSetting &&
                    undefined != item.moreSetting.decimalPoint &&
                    item.moreSetting.decimalPoint != -1
                  ) {
                    text = parseFloat(text + '').toFixed(
                      item.moreSetting.decimalPoint
                    )
                  }
                  if (item.isCapital && item.isCapital === 'true') {
                    text =
                      '¥' +
                      text +
                      '<br>大写金额（人民币）：' +
                      convertCurrency(text)
                  }
                } else if (
                  text &&
                  (item.fieldType === 'CascadeDropDown' ||
                    item.fieldType === 'CUSTOMIZE_RadioButton')
                ) {
                  if (text.length > 1) {
                    var textTmp = ''
                    for (var i = 0; i < text.length; i++) {
                      textTmp += text[i]
                      if (i < text.length - 1) {
                        textTmp += '/'
                      }
                    }
                    text = textTmp
                  }
                }
              }
              return (
                <div
                  contentEditable={false}
                  dangerouslySetInnerHTML={{ __html: text }}
                ></div>
              )
            },
          },
        ]
        for (var i = 0; i < formFields.length; i++) {
          var item = formFields[i]
          if (item.fieldType === 'SectionBreak') {
            continue
          }
          if (!item.isVisible) {
            continue
          }
          if (item.moreSetting && item.moreSetting.notPrint == true) {
            continue
          }
          var rowData = {
            col_1: item.fieldTitle,
            col_2: this.formatValue(item, data[item.fieldId]),
          }
          newRows.splice(newRows.length, 0, rowData)
        }
      } else {
        newColumns = FORM_TABLE_COLUMNS
        for (var i = 0; i < formFields.length; i++) {
          var item = formFields[i]
          if (item.fieldType === 'SectionBreak') {
            continue
          }
          if (!item.isVisible) {
            continue
          }
          if (item.moreSetting && item.moreSetting.notPrint == true) {
            continue
          }

          var rowData = {}
          if (i < formFields.length - 1) {
            var isShowNextField = true
            if (formFields[i + 1].fieldType === 'SectionBreak') {
              isShowNextField = false
            }
            if (!formFields[i + 1].isVisible) {
              isShowNextField = false
            }
            if (
              formFields[i + 1].moreSetting &&
              formFields[i + 1].moreSetting.notPrint == true
            ) {
              isShowNextField = false
            }

            if (isShowNextField) {
              rowData = {
                col_1: item.fieldTitle,
                col_2: this.formatValue(item, data[item.fieldId]),
                col_3: formFields[i + 1].fieldTitle,
                col_4: this.formatValue(
                  formFields[i + 1],
                  data[formFields[i + 1].fieldId]
                ),
              }
            } else {
              rowData = {
                col_1: item.fieldTitle,
                col_2: this.formatValue(item, data[item.fieldId]),
                col_3: '',
                col_4: '',
              }
            }
          } else {
            rowData = {
              col_1: item.fieldTitle,
              col_2: this.formatValue(item, data[item.fieldId]),
              col_3: '',
              col_4: '',
            }
          }

          newRows.splice(newRows.length, 0, rowData)
          i = i + 1
        }
      }
    }

    if (newRows.length > 0) {
      return (
        <span>
          <div
            className={styles.sgridRowItem}
            style={{
              width: 740,
              fontWeight: 'bold',
              justifyContent: 'center',
              border: 'none',
              top: 70,
              overflow: 'hidden',
            }}
          >
            <span>{fieldTitle}</span>
          </div>
          <Table
            size={'small'}
            bordered={true}
            pagination={false}
            loading={false}
            className={styles.sgridRowItem}
            style={{ top: 70, width: '100%', border: 'none', fontSize: 12 }}
            columns={newColumns}
            dataSource={newRows}
            showHeader={false}
          />
        </span>
      )
    } else {
      return <span></span>
    }
  }

  initFormTable(formFields) {
    let newColumns = []
    let newRows = []
    if (formFields) {
      if (formFields.length <= 8) {
        newColumns = [
          {
            title: '',
            dataIndex: 'col_1',
            key: 'col_1',
            width: 199,
            align: 'center',
          },
          {
            title: '',
            dataIndex: 'col_2',
            key: 'col_2',
            width: 597,
            align: 'left',
            render: (text, row, index) => {
              return (
                <div
                  contentEditable={false}
                  dangerouslySetInnerHTML={{ __html: text }}
                ></div>
              )
            },
          },
        ]
        for (var i = 0; i < formFields.length; i++) {
          var item = formFields[i]
          if (
            item.fieldType === 'SectionBreak' ||
            item.fieldType === 'ChildField' ||
            item.fieldType === 'FORMREFCustomerField'
          ) {
            continue
          }
          if (!item.isVisible) {
            continue
          }
          if (item.moreSetting && item.moreSetting.notPrint == true) {
            continue
          }
          var data = {
            col_1: item.fieldTitle,
            col_2: this.getFieldValue(
              undefined,
              item.fieldId,
              this.state.formFieldValues
            ),
          }
          newRows.splice(newRows.length, 0, data)
        }
      } else {
        newColumns = FORM_TABLE_COLUMNS
        for (var i = 0; i < formFields.length; i++) {
          var item = formFields[i]
          if (
            item.fieldType === 'SectionBreak' ||
            item.fieldType === 'ChildField' ||
            item.fieldType === 'FORMREFCustomerField'
          ) {
            continue
          }
          if (!item.isVisible) {
            continue
          }
          if (item.moreSetting && item.moreSetting.notPrint == true) {
            continue
          }
          var data = {}
          if (i < formFields.length - 1) {
            var isShowNextField = true
            if (
              formFields[i + 1].fieldType === 'SectionBreak' ||
              formFields[i + 1].fieldType === 'ChildField' ||
              formFields[i + 1].fieldType === 'FORMREFCustomerField'
            ) {
              isShowNextField = false
            }
            if (!formFields[i + 1].isVisible) {
              isShowNextField = false
            }
            if (
              formFields[i + 1].moreSetting &&
              formFields[i + 1].moreSetting.notPrint == true
            ) {
              isShowNextField = false
            }
            if (isShowNextField) {
              data = {
                col_1: item.fieldTitle,
                col_2: this.getFieldValue(
                  undefined,
                  item.fieldId,
                  this.state.formFieldValues
                ),
                col_3: formFields[i + 1].fieldTitle,
                col_4: this.getFieldValue(
                  undefined,
                  formFields[i + 1].fieldId,
                  this.state.formFieldValues
                ),
              }
            } else {
              data = {
                col_1: item.fieldTitle,
                col_2: this.getFieldValue(
                  undefined,
                  item.fieldId,
                  this.state.formFieldValues
                ),
                col_3: '',
                col_4: '',
              }
            }
          } else {
            data = {
              col_1: item.fieldTitle,
              col_2: this.getFieldValue(
                undefined,
                item.fieldId,
                this.state.formFieldValues
              ),
              col_3: '',
              col_4: '',
            }
          }

          newRows.splice(newRows.length, 0, data)
          i = i + 1
        }
      }
    }

    this.setState({ Fcolumns: newColumns, Frows: newRows })
  }

  initFormLogTable(dataList) {
    let newColumns = [
      {
        title: '步骤',
        dataIndex: 'col_1',
        key: 'col_1',
        width: 50,
        align: 'center',
      },
      {
        title: '节点名称',
        dataIndex: 'col_2',
        key: 'col_2',
        width: 150,
        align: 'center',
      },
      {
        title: '类型',
        dataIndex: 'col_3',
        key: 'col_3',
        width: 60,
        align: 'center',
      },
      {
        title: '处理人',
        dataIndex: 'col_4',
        key: 'col_4',
        width: 90,
        align: 'center',
      },
      {
        title: '处理意见',
        dataIndex: 'col_5',
        key: 'col_5',
        width: 240,
        align: 'center',
        render: (text, row, index) => {
          return (
            <div
              style={{ whiteSpace: 'pre-wrap' }}
              contentEditable={false}
              dangerouslySetInnerHTML={{ __html: text }}
            ></div>
          )
        },
      },
      {
        title: '处理时间',
        dataIndex: 'col_6',
        key: 'col_6',
        width: 130,
        align: 'center',
      },
    ]
    let newRows = []
    if (dataList) {
      var data = {}
      for (var i = 0; i < dataList.length; i++) {
        if (dataList[i].type === 1 || dataList[i].type === 3) {
          continue
        }
        var opDesc = dataList[i].opDesc
        if (dataList[i].type === 3) {
          if (dataList[i].expand) {
            dataList[i].expand = JSON.parse(dataList[i].expand)
            if (dataList[i].expand.commentImage.length > 0) {
              opDesc +=
                '<br> <img style="width:60px;height:60px;" src="' +
                process.env.API_HOST +
                '/file/download?fileUrl=' +
                dataList[i].expand.commentImage[0].url +
                '&fileName=' +
                dataList[i].expand.commentImage[0].name +
                '">'
            }

            if (dataList[i].expand.commentFile.length > 0) {
              var tmp = ''
              for (var j = 0; j < dataList[i].expand.commentFile.length; j++) {
                tmp += dataList[i].expand.commentFile[j].name
                if (j < dataList[i].expand.commentFile.length - 1) {
                  tmp += '<br> '
                }
              }
              if (tmp) {
                opDesc += '<br>' + tmp
              }
            }
          }
        }
        data = {
          col_1: newRows.length + 1,
          col_2: dataList[i].flowNodeName,
          col_3: dataList[i].opAction,
          col_4: dataList[i].opUserName,
          col_5: opDesc,
          col_6: moment(dataList[i].opTime).format('YYYY-MM-DD HH:mm'),
        }
        newRows.splice(newRows.length, 0, data)
      }
    }
    this.setState({ Pcolumns: newColumns, Prows: newRows })
  }

  initExFieldTable(dataList) {
    let newColumns = [
      {
        title: '',
        dataIndex: 'col_1',
        key: 'col_1',
        width: 398,
        align: 'center',
      },
      {
        title: '',
        dataIndex: 'col_2',
        key: 'col_2',
        width: 398,
        align: 'left',
        render: (text, row, index) => {
          return (
            <div
              contentEditable={false}
              dangerouslySetInnerHTML={{ __html: text }}
            ></div>
          )
        },
      },
    ]
    let newRows = []
    if (dataList) {
      var data = {}
      for (var i = 0; i < dataList.length; i++) {
        var item = dataList[i]
        if (item.fieldType == 'ImageField') {
          continue
        }
        data = {
          col_1: item.fieldTitle,
          col_2: this.formatValue(item, item.fieldValue),
        }
        newRows.splice(newRows.length, 0, data)
      }
    }
    this.setState({ Ncolumns: newColumns, Nrows: newRows })
  }

  setFormFieldVisibleStatus = (formFieldList) => {
    var visibleFormFields = []
    var visibleFormFieldsTag = []
    for (var i = 0; i < formFieldList.length; i++) {
      if (formFieldList[i].multipleValue) {
        for (var j = 0; j < formFieldList[i].multipleValue.length; j++) {
          if (
            formFieldList[i].multipleValue[j].showFormFields &&
            formFieldList[i].multipleValue[j].showFormFields.length > 0
          ) {
            var showFormFields =
              formFieldList[i].multipleValue[j].showFormFields
            for (var k = 0; k < showFormFields.length; k++) {
              if (visibleFormFieldsTag.indexOf(showFormFields[k]) >= 0) {
                var value = []
                var index = 0
                for (var m = 0; m < visibleFormFields.length; m++) {
                  if (visibleFormFields[m].key === showFormFields[k]) {
                    value = visibleFormFields[m].value
                    index = m
                    break
                  }
                }
                value.splice(
                  value.length,
                  0,
                  formFieldList[i].multipleValue[j].name
                )
                visibleFormFields.splice(index, 1, {
                  key: showFormFields[k],
                  index: i,
                  value: value,
                })
              } else {
                visibleFormFieldsTag.splice(
                  visibleFormFieldsTag.length,
                  0,
                  showFormFields[k]
                )
                visibleFormFields.splice(visibleFormFields.length, 0, {
                  key: showFormFields[k],
                  index: i,
                  value: [formFieldList[i].multipleValue[j].name],
                })
              }
            }
          }
        }
      }
    }
    for (var i = 0; i < formFieldList.length; i++) {
      formFieldList[i].isVisible = true
      this.formFieldVisible[formFieldList[i].fieldId] = true
      for (var j = 0; j < visibleFormFields.length; j++) {
        if (visibleFormFields[j].key === formFieldList[i].fieldId) {
          var value = visibleFormFields[j].value
          formFieldList[i].isVisible = false
          this.formFieldVisible[formFieldList[i].fieldId] = false
          for (var k = 0; k < value.length; k++) {
            if (
              formFieldList[visibleFormFields[j].index].inputValue.indexOf(
                value[k]
              ) >= 0
            ) {
              formFieldList[i].isVisible = true
              this.formFieldVisible[formFieldList[i].fieldId] = false
              break
            }
          }
        }
      }
    }

    return formFieldList
  }

  async getPrintDataForm() {
    const res = await _printDataForm(this.state.formDataId)
    if (res.code === 0) {
      res.data.formFieldValues.map((item) => {
        item.fieldValue = JSON.parse(item.fieldValue)
      })

      res.data.formFields.map((item) => {
        item.inputValue = []

        if (
          item.fieldType == 'ChildField' ||
          item.fieldType == 'FORMREFCustomerField'
        ) {
          item.childFormFields.map((subItem) => {
            if (subItem.multipleValue) {
              subItem.multipleValue = JSON.parse(subItem.multipleValue)
            }
            if (subItem.moreSetting) {
              subItem.moreSetting = JSON.parse(subItem.moreSetting)
            }
          })
        }

        res.data.formFieldValues.map((subItem) => {
          if (subItem.formFieldId === item.fieldId && subItem.fieldValue) {
            if (item.fieldType == 'FORMREFCustomerField') {
              var inputValue = []
              for (let index = 0; index < subItem.fieldValue.length; index++) {
                const element = subItem.fieldValue[index]
                inputValue.push(element.fieldList)
              }
              item.inputValue = inputValue
            } else {
              item.inputValue = subItem.fieldValue
            }
          }
        })

        if (item.multipleValue) {
          item.multipleValue = JSON.parse(item.multipleValue)
        }

        if (item.moreSetting) {
          item.moreSetting = JSON.parse(item.moreSetting)
        }
      })

      res.data.nodeExFieldList.map((item) => {
        item.fieldValue = JSON.parse(item.fieldValue)
      })

      var formPrintCfg
      if (res.data.formPrintCfg) {
        formPrintCfg = JSON.parse(res.data.formPrintCfg)
      }

      this.setState(
        {
          toaDataForm: res.data.toaDataForm,
          departName: res.data.departName,
          formFieldValues: res.data.formFieldValues,
          formFields: this.setFormFieldVisibleStatus(res.data.formFields),
          toaDataFormLogs: res.data.toaDataFormLogs,
          nodeExFieldList: res.data.nodeExFieldList,
          jsapiticket: res.data.jsapiticket,
          appId: res.data.appId,
          formPrintCfg: formPrintCfg,
        },
        () =>
          setTimeout(() => {
            if (this.state.formPrintCfg) {
              if (
                this.state.formPrintCfg['printSetting'] &&
                this.state.formPrintCfg['printSetting'].pageOrientations ==
                  '横向'
              ) {
                this.printCanvas_width = 1046
                var style = document.createElement('style')
                document.head.appendChild(style)
                style.sheet.insertRule('@page { size: landscape; }', 0)
              }
              var hotInstance = this.hotTableComponent.current.hotInstance
              var contentRow = this.state.formPrintCfg['contentRow'].length
              var contentCol = this.state.formPrintCfg['contentCol'].length
              for (var i = 0; i < contentRow; i++) {
                this.dataset[i] = new Array()
                for (var j = 0; j < contentCol; j++) {
                  this.dataset[i][j] = ''
                }
              }
              hotInstance.render()

              var flowList = []
              for (var i = 0; i < this.state.toaDataFormLogs.length; i++) {
                if (this.state.toaDataFormLogs[i].type === 2) {
                  flowList.push(this.state.toaDataFormLogs[i])
                }
              }

              if (this.state.formPrintCfg['contentCol']) {
                var colWidths = this.state.formPrintCfg['contentCol']
                var tWidth = 0
                for (var i = 0; i < colWidths.length; i++) {
                  tWidth += colWidths[i]
                }
                if (tWidth < this.printCanvas_width) {
                  for (var i = 0; i < colWidths.length; i++) {
                    colWidths[i] =
                      (colWidths[i] / tWidth) * this.printCanvas_width
                  }
                }
                this.hotSettings.colWidths = colWidths
              }
              if (this.state.formPrintCfg['contentRow']) {
                this.hotSettings.rowHeights =
                  this.state.formPrintCfg['contentRow']
              }
              hotInstance.updateSettings(this.hotSettings, false)

              var cellsMetaMap = this.state.formPrintCfg['cells']
              var childFieldMap = {}
              var flowLogMap = {}
              for (var key in cellsMetaMap) {
                var rowIndex = parseInt(key.split(':')[0])
                var colIndex = parseInt(key.split(':')[1])
                if (rowIndex >= contentRow || colIndex >= contentCol) {
                  continue
                }
                this.dataset[rowIndex][colIndex] = ''
                var cellProperties = cellsMetaMap[key]
                cellProperties.readOnly = true
                if (cellProperties.content || cellProperties.className) {
                  if (cellProperties.content) {
                    if (cellProperties.hasField) {
                      var text = ''
                      for (
                        var i = 0;
                        i < cellProperties.content[0].fields.length;
                        i++
                      ) {
                        var fieldId = cellProperties.content[0].fields[i]
                        var fieldValue = ''
                        if (fieldId === 'sys_instanceTitle') {
                          fieldValue = this.state.toaDataForm.instanceTitle
                        } else if (fieldId === 'sys_department') {
                          fieldValue = this.state.departName
                        } else if (fieldId === 'sys_creator') {
                          fieldValue = this.state.toaDataForm.createUserName
                        } else if (fieldId === 'sys_createtime') {
                          fieldValue = moment(
                            this.state.toaDataForm.createTime
                          ).format('YYYY-MM-DD HH:mm:ss')
                        } else if (fieldId === 'sys_approvesign') {
                          fieldValue = ''
                          for (var j = flowList.length - 1; j >= 0; j--) {
                            fieldValue += flowList[j].opUserName
                            if (j > 0) {
                              fieldValue += '-'
                            }
                          }
                        } else if (fieldId.indexOf('flow_') == 0) {
                          if (!flowLogMap[fieldId]) {
                            flowLogMap[fieldId] = {
                              rowIndex: rowIndex,
                              colIndex: colIndex,
                            }
                          }
                        } else {
                          if (fieldId.indexOf('/') > 0) {
                            var parentId = fieldId.split('/')[0]
                            var isFORMREFCustomerField = false
                            for (
                              let index = 0;
                              index < this.state.formFields.length;
                              index++
                            ) {
                              const element = this.state.formFields[index]
                              if (
                                element.fieldId == parentId &&
                                element.fieldType == 'FORMREFCustomerField'
                              ) {
                                isFORMREFCustomerField = true
                                break
                              }
                            }
                            fieldId = fieldId.split('/')[1]
                            if (isFORMREFCustomerField) {
                              fieldValue = this.getFieldValue(
                                parentId,
                                fieldId,
                                this.state.formFieldValues
                              )
                            } else {
                              if (!childFieldMap[parentId]) {
                                childFieldMap[parentId] = {
                                  parentId: parentId,
                                  fieldId: fieldId,
                                  rowIndex: rowIndex,
                                }
                              }
                            }
                          } else {
                            fieldValue = this.getFieldValue(
                              undefined,
                              fieldId,
                              this.state.formFieldValues
                            )
                          }
                          if (!fieldValue) {
                            fieldValue = ''
                          }
                        }

                        if (text == '') {
                          text = fieldValue
                        } else {
                          if (fieldValue != '') {
                            text += '_' + fieldValue
                          }
                        }
                      }

                      hotInstance.setDataAtCell(rowIndex, colIndex, text)
                    } else {
                      hotInstance.setDataAtCell(
                        rowIndex,
                        colIndex,
                        cellProperties.content[0]
                      )
                    }
                  }
                  if (cellProperties.colspan || cellProperties.rowspan) {
                    if (!this.mergeCellIntance) {
                      this.mergeCellIntance =
                        hotInstance.getPlugin('mergeCells')
                    }
                    this.mergeCellIntance.merge(
                      rowIndex,
                      colIndex,
                      rowIndex + cellProperties.rowspan - 1,
                      colIndex + cellProperties.colspan - 1
                    )
                  }
                }
                hotInstance.setCellMetaObject(
                  rowIndex,
                  colIndex,
                  cellProperties
                )
              }

              var addRowCount = 0

              if (this.state.formPrintCfg.printSetting.childPrintType === '1') {
                //套打类
                for (var parentId in childFieldMap) {
                  var fieldValue
                  for (var j = 0; j < this.state.formFieldValues.length; j++) {
                    if (
                      this.state.formFieldValues[j].formFieldId === parentId
                    ) {
                      hotInstance.alter(
                        'insert_row',
                        childFieldMap[parentId].rowIndex,
                        this.state.formFieldValues[j].fieldValue.length
                      )
                      addRowCount +=
                        this.state.formFieldValues[j].fieldValue.length
                      fieldValue = this.state.formFieldValues[j].fieldValue
                      break
                    }
                  }
                  if (fieldValue) {
                    for (
                      var i = childFieldMap[parentId].rowIndex;
                      i <
                      childFieldMap[parentId].rowIndex +
                        this.state.formFieldValues[j].fieldValue.length;
                      i++
                    ) {
                      for (var k = 0; k < contentCol; k++) {
                        var cellProperties = hotInstance.getCellMeta(
                          childFieldMap[parentId].rowIndex + addRowCount,
                          k
                        )
                        var newCellProperties = hotInstance.getCellMeta(i, k)
                        newCellProperties.borderType = cellProperties.borderType
                        newCellProperties.borderWidth =
                          cellProperties.borderWidth
                        newCellProperties.ftSize = cellProperties.ftSize
                        newCellProperties.ftColor = cellProperties.ftColor
                        newCellProperties.bgColor = cellProperties.bgColor
                        newCellProperties.rowspan = cellProperties.rowspan
                        newCellProperties.colspan = cellProperties.colspan
                        newCellProperties.className = 'htCenter htMiddle'
                        var inputValue = ''
                        if (
                          cellProperties.content &&
                          cellProperties.content[0] &&
                          cellProperties.content[0].fields
                        ) {
                          var fieldId = cellProperties.content[0].fields[0]
                          fieldId = fieldId.replace(parentId + '/', '')
                          var index = i - childFieldMap[parentId].rowIndex
                          inputValue = fieldValue[index][fieldId]
                          if (inputValue) {
                            var field = this.getField(
                              fieldId,
                              this.state.formFields
                            )
                            inputValue = this.formatValue(field, inputValue)
                          }
                        }
                        if (cellProperties.colspan) {
                          if (!this.mergeCellIntance) {
                            this.mergeCellIntance =
                              hotInstance.getPlugin('mergeCells')
                          }
                          this.mergeCellIntance.merge(
                            i,
                            k,
                            i,
                            k + cellProperties.colspan - 1
                          )
                          if (inputValue) {
                            hotInstance.setDataAtCell(i, k, inputValue)
                          } else {
                            hotInstance.setDataAtCell(i, k, '')
                          }
                          k += cellProperties.colspan - 1
                        } else {
                          if (inputValue) {
                            hotInstance.setDataAtCell(i, k, inputValue)
                          } else {
                            hotInstance.setDataAtCell(i, k, '')
                          }
                        }
                        hotInstance.setCellMetaObject(i, k, newCellProperties)
                        hotInstance.render()
                      }
                    }
                  }
                }
              } else {
                //列表类
              }

              var isInsertFlowRow = false
              for (var key in flowLogMap) {
                var rowIndex = flowLogMap[key].rowIndex + addRowCount
                var colIndex = flowLogMap[key].colIndex
                if (!isInsertFlowRow) {
                  hotInstance.alter('insert_row', rowIndex + 1, flowList.length)
                  isInsertFlowRow = true
                }
                for (var i = rowIndex; i < rowIndex + flowList.length; i++) {
                  var cellProperties = hotInstance.getCellMeta(
                    rowIndex,
                    colIndex
                  )
                  var newCellProperties = hotInstance.getCellMeta(i, colIndex)
                  newCellProperties.borderType = cellProperties.borderType
                  newCellProperties.borderWidth = cellProperties.borderWidth
                  newCellProperties.ftSize = cellProperties.ftSize
                  newCellProperties.ftColor = cellProperties.ftColor
                  newCellProperties.bgColor = cellProperties.bgColor
                  newCellProperties.rowspan = cellProperties.rowspan
                  newCellProperties.colspan = cellProperties.colspan
                  newCellProperties.className = 'htCenter htMiddle'
                  var inputValue = ''
                  if (cellProperties.content) {
                    var fieldId = cellProperties.content[0].fields[0]
                    var index = i - rowIndex
                    if (fieldId === 'flow_id') {
                      inputValue = index + 1
                    } else if (fieldId === 'flow_createtime') {
                      inputValue = moment(flowList[index].opTime).format(
                        'YYYY-MM-DD HH:mm:ss'
                      )
                    } else if (fieldId === 'flow_content') {
                      inputValue = flowList[index].opDesc
                    } else if (fieldId === 'flow_approver') {
                      inputValue = flowList[index].opUserName
                    } else if (fieldId === 'flow_nodename') {
                      inputValue = flowList[index].flowNodeName
                    } else if (fieldId === 'flow_approveresult') {
                      inputValue = flowList[index].opAction
                    }
                  }
                  if (cellProperties.colspan) {
                    if (!this.mergeCellIntance) {
                      this.mergeCellIntance =
                        hotInstance.getPlugin('mergeCells')
                    }
                    this.mergeCellIntance.merge(
                      i,
                      colIndex,
                      i,
                      colIndex + cellProperties.colspan - 1
                    )
                    if (inputValue) {
                      hotInstance.setDataAtCell(i, colIndex, inputValue)
                    }
                    k += cellProperties.colspan - 1
                  } else {
                    if (inputValue) {
                      hotInstance.setDataAtCell(i, colIndex, inputValue)
                    }
                  }
                  hotInstance.setCellMetaObject(i, colIndex, newCellProperties)
                  hotInstance.render()
                }
              }

              hotInstance.render()
            } else {
              this.initFormTable(this.state.formFields)
              this.initFormLogTable(this.state.toaDataFormLogs)
              this.initExFieldTable(this.state.nodeExFieldList)
            }
            this.settingWx()
            // if (this.state.topWarnShow) {
            //     this.initPrint();
            // }
          }),
        10
      )
    } else if (res.code === 3003) {
      this.setState({ tipModal: true })
    } else {
      Toast.offline(res.msg, 3)
      this.props.history.push('/')
    }
  }

  initPrint() {
    var iframe = document.createElement('IFRAME')
    iframe.setAttribute(
      'style',
      'position:absolute;width:0px;height:0px;left:500px;top:500px;'
    )
    iframe.setAttribute('id', 'printIframe')
    iframe.setAttribute(
      'src',
      process.env.MAIN_HOST +
        'formprint?formDataId=' +
        this.state.formDataId +
        '&isPrint=1'
    )
    document.body.appendChild(iframe)

    return iframe
  }

  print() {
    // 防止重复点击导致弹出多个打印框
    if (this.isPrinting) {
      return
    }
    this.isPrinting = true

    document.getElementById('topWarn').style.display = 'none'
    setTimeout(() => {
      window.print()
      // 打印完成后重置标记，并恢复显示
      setTimeout(() => {
        this.isPrinting = false
        document.getElementById('topWarn').style.display = 'block'
      }, 500)
    }, 20)
  }

  render() {
    if (this.state.hasError) {
      return <h1>出错了...</h1>
    }
    return (
      <div id="printMain">
        {this.state.topWarnShow ? (
          <div
            id="topWarn"
            className={styles.topWarn}
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              zIndex: 9,
              width: '100%',
              opacity: 0.9,
            }}
          >
            <div className={styles.topWarnText}>
              <span>可分享本页面进行打印</span>
            </div>
            <div className={styles.topIcons} style={{ marginLeft: 15 }}>
              <CopyToClipboard
                text={
                  process.env.MAIN_HOST +
                  'formprint?formDataId=' +
                  this.state.formDataId
                }
                onCopy={() => {
                  Toast.info('复制成功', 1)
                }}
              >
                <span className={styles.printTopItem}>
                  <i
                    class={[`${styles.iconNtn}`, `${styles.iconBtnCopy}`].join(
                      ' '
                    )}
                  ></i>
                  <span>复制链接</span>
                </span>
              </CopyToClipboard>
              {this.state.isPrintBtnShow ? (
                <span
                  className={styles.printTopItem}
                  onClick={() => {
                    this.print()
                  }}
                >
                  <i
                    className={[
                      `${styles.iconNtn}`,
                      `${styles.iconBtnPrint}`,
                    ].join(' ')}
                  ></i>
                  <span>打印</span>
                </span>
              ) : (
                ''
              )}
            </div>
          </div>
        ) : (
          ''
        )}
        <Modal
          visible={this.state.tipModal}
          transparent
          maskClosable={false}
          title="提示"
          footer={[
            { text: '确定', onPress: () => this.props.history.push('/') },
          ]}
        >
          <div style={{ height: 25 }}>此工单信息已被删除</div>
        </Modal>
        <div
          id="printCanvas"
          className={styles.printCanvas}
          style={{
            width:
              this.state.formPrintCfg &&
              this.state.formPrintCfg.printSetting.pageOrientations == '横向'
                ? '1100px'
                : '796px',
          }}
        >
          {this.state.formPrintCfg ? (
            <div
              className={styles.canvas}
              style={{ minHeight: Math.min(document.body.clientHeight, 700) }}
            >
              <HotTable
                ref={this.hotTableComponent}
                settings={this.hotSettings}
                style={{ left: 12 }}
                width="100%"
                height="auto"
                licenseKey="non-commercial-and-evaluation"
              />
              {<div className={styles.previewMask}></div>}
              {!this.state.toaDataForm ||
              (this.state.toaDataForm &&
                this.state.formPrintCfg &&
                this.state.formPrintCfg.printSetting.approvalStatus ==
                  false) ? (
                ''
              ) : this.state.toaDataForm.status === 0 ? (
                <img
                  className={styles.formIconStatus_}
                  src={require('../../assets/img/img_review.png')}
                ></img>
              ) : this.state.toaDataForm.status === 1 ? (
                <img
                  className={styles.formIconStatus_}
                  src={require('../../assets/img/img_suss_approve.png')}
                ></img>
              ) : this.state.toaDataForm.status === 2 ? (
                <img
                  className={styles.formIconStatus_}
                  src={require('../../assets/img/img_approve.png')}
                ></img>
              ) : this.state.toaDataForm.status === -1 ? (
                <img
                  className={styles.formIconStatus_}
                  src={require('../../assets/img/img_suss_close.png')}
                ></img>
              ) : this.state.toaDataForm.status === 99 ? (
                <img
                  className={styles.formIconStatus_}
                  src={require('../../assets/img/img_suss_close.png')}
                ></img>
              ) : this.state.toaDataForm.status === -2 ? (
                <img
                  className={styles.formIconStatus_}
                  src={require('../../assets/img/img_close.png')}
                ></img>
              ) : (
                ''
              )}
            </div>
          ) : (
            <div className={styles.canvas}>
              {
                <div
                  className={styles.previewMask}
                  style={{ position: 'fixed', top: '38px' }}
                ></div>
              }
              {this.state.toaDataForm.instanceTitle ? (
                <div className={styles.sgrid}>
                  <div
                    className={styles.sgridRowItem}
                    style={{
                      top: 20,
                      left: 0,
                      width: 740,
                      height: 'auto',
                      fontSize: 19,
                      justifyContent: 'center',
                      border: 'none',
                      overflow: 'hidden',
                      paddingTop: 20,
                      paddingBottom: 45,
                    }}
                  >
                    <span>{this.state.toaDataForm.instanceTitle}</span>
                  </div>
                  <div
                    className={styles.sgridRowItem}
                    style={{
                      top: 60,
                      left: 0,
                      width: 55,
                      fontWeight: 'bold',
                      border: 'none',
                      overflow: 'hidden',
                    }}
                  >
                    <span>提单人</span>
                  </div>
                  <div
                    className={styles.sgridRowItem}
                    style={{
                      top: 60,
                      width: 155,
                      border: 'none',
                      overflow: 'hidden',
                    }}
                  >
                    <span>{this.state.toaDataForm.createUserName}</span>
                  </div>
                  <div
                    className={styles.sgridRowItem}
                    style={{
                      top: 60,
                      width: 41,
                      fontWeight: 'bold',
                      border: 'none',
                      overflow: 'hidden',
                    }}
                  >
                    <span>部门</span>
                  </div>
                  <div
                    className={styles.sgridRowItem}
                    style={{
                      top: 60,
                      width: 260,
                      border: 'none',
                      overflow: 'hidden',
                    }}
                  >
                    <span>{this.state.departName}</span>
                  </div>
                  <div
                    className={styles.sgridRowItem}
                    style={{
                      top: 60,
                      width: 67,
                      fontWeight: 'bold',
                      border: 'none',
                      overflow: 'hidden',
                    }}
                  >
                    <span>提单时间</span>
                  </div>
                  <div
                    className={styles.sgridRowItem}
                    style={{
                      top: 60,
                      width: 160,
                      border: 'none',
                      overflow: 'hidden',
                    }}
                  >
                    <span>
                      {moment(this.state.toaDataForm.createTime).format(
                        'YYYY-MM-DD HH:mm:ss'
                      )}
                    </span>
                  </div>
                  {this.state.Frows.length > 0 ? (
                    <Table
                      size={'small'}
                      bordered={true}
                      pagination={false}
                      loading={false}
                      className={styles.sgridRowItem}
                      style={{
                        top: 70,
                        width: '100%',
                        border: 'none',
                        fontSize: 12,
                      }}
                      columns={this.state.Fcolumns}
                      dataSource={this.state.Frows}
                      showHeader={false}
                    />
                  ) : (
                    ''
                  )}
                  {this.state.formFields && this.state.formFields.length > 0 ? (
                    <span>
                      {this.state.formFields.map((item, index) => {
                        if (
                          item.fieldType === 'ChildField' ||
                          item.fieldType === 'FORMREFCustomerField'
                        ) {
                          if (
                            item.moreSetting &&
                            item.moreSetting.notPrint == true
                          ) {
                          } else {
                            if (this.state.childFieldPrintType === 0) {
                              return this.renderChildForm_(item)
                            } else {
                              return this.renderChildForm(
                                item.fieldId,
                                item.fieldTitle,
                                item.childFormFields
                              )
                            }
                          }
                        }
                      })}
                    </span>
                  ) : (
                    ''
                  )}
                  {this.state.nodeExFieldList.length >= 1 ? (
                    <div
                      className={styles.sgridRowItem}
                      style={{
                        width: 740,
                        fontWeight: 'bold',
                        justifyContent: 'center',
                        border: 'none',
                        top: 70,
                        overflow: 'hidden',
                        padding: '20px 0px  10px 0px',
                      }}
                    >
                      <span>
                        审批内容：{this.state.toaDataForm.instanceTitle}
                      </span>
                    </div>
                  ) : (
                    ''
                  )}
                  {this.state.Nrows.length > 0 ? (
                    <Table
                      size={'small'}
                      bordered={true}
                      pagination={false}
                      loading={false}
                      className={styles.sgridRowItem}
                      style={{
                        top: 70,
                        width: '100%',
                        border: 'none',
                        fontSize: 12,
                      }}
                      columns={this.state.Ncolumns}
                      dataSource={this.state.Nrows}
                      showHeader={false}
                    />
                  ) : (
                    ''
                  )}
                  {this.state.Prows.length > 0 ? (
                    <div
                      className={styles.sgridRowItem}
                      style={{
                        width: 740,
                        fontWeight: 'bold',
                        justifyContent: 'center',
                        border: 'none',
                        top: 70,
                        overflow: 'hidden',
                        padding: '20px 0px  10px 0px',
                      }}
                    >
                      <span>
                        处理流程：{this.state.toaDataForm.instanceTitle}
                      </span>
                    </div>
                  ) : (
                    ''
                  )}
                  {this.state.Prows.length > 0 ? (
                    <Table
                      size={'small'}
                      bordered={true}
                      pagination={false}
                      loading={false}
                      className={styles.sgridRowItem}
                      style={{
                        top: 70,
                        width: '100%',
                        border: 'none',
                        fontSize: 12,
                      }}
                      columns={this.state.Pcolumns}
                      dataSource={this.state.Prows}
                    />
                  ) : (
                    ''
                  )}
                </div>
              ) : (
                ''
              )}
              {!this.state.toaDataForm ? (
                ''
              ) : this.state.toaDataForm.status === 0 ? (
                <img
                  className={styles.formIconStatus}
                  src={require('../../assets/img/img_review.png')}
                ></img>
              ) : this.state.toaDataForm.status === 1 ? (
                <img
                  className={styles.formIconStatus}
                  src={require('../../assets/img/img_suss_approve.png')}
                ></img>
              ) : this.state.toaDataForm.status === 2 ? (
                <img
                  className={styles.formIconStatus}
                  src={require('../../assets/img/img_approve.png')}
                ></img>
              ) : this.state.toaDataForm.status === -1 ? (
                <img
                  className={styles.formIconStatus}
                  src={require('../../assets/img/img_suss_close.png')}
                ></img>
              ) : this.state.toaDataForm.status === 99 ? (
                <img
                  className={styles.formIconStatus}
                  src={require('../../assets/img/img_suss_close.png')}
                ></img>
              ) : this.state.toaDataForm.status === -2 ? (
                <img
                  className={styles.formIconStatus}
                  src={require('../../assets/img/img_close.png')}
                ></img>
              ) : (
                ''
              )}
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default withCookies(FormPrintPage)

